import { translate as mainTranslate } from 'loankeeper-common/helpers'

export const translate = (key: string): string => mainTranslate(`frm_Sec_pass_change-${key}`)
export const translateGroupAddEdit = (key: string): string => mainTranslate(`frm_group_add_edit-${key}`)
export const translateLKM = (key: string): string => mainTranslate(`LKMESSAGE-${key}`)
export const translateWeb = (key: string): string => mainTranslate(`frm_web_messages-${key}`)

const preventHandler = (event: Event) => {
  event.preventDefault()
}

export const preventDefaultListeners = {
  onCopy: preventHandler,
  onCut: preventHandler,
  onPaste: preventHandler,
  onDrag: preventHandler,
  onDrop: preventHandler,
}
